import { useParams, useNavigate } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { useAppointments } from '../../contexts/AppointmentsContext';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import { ROUTES } from '../../config/constants';
import AppointmentForm from './components/AppointmentForm';

const EditAppointmentPage = () => {
  const { appointmentId } = useParams();
  const navigate = useNavigate();
  const { getAppointmentById, status } = useAppointments();

  if (status === 'loading') {
    return (
      <div className="flex flex-col gap-2">
        <div className="h-24 animate-pulse rounded-2xl bg-slate-100" />
        <div className="h-24 animate-pulse rounded-2xl bg-slate-100" />
      </div>
    );
  }

  const appointment = getAppointmentById(appointmentId);

  if (!appointment) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl font-bold text-slate-900">Cita no encontrada</h1>
        <Card>
          <p className="text-sm text-slate-600">
            Esta cita no existe o fue eliminada.
          </p>
          <div className="mt-3">
            <Button
              variant="secondary"
              fullWidth
              onClick={() => navigate(ROUTES.CALENDAR)}
            >
              Volver al calendario
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-2">
        <CalendarDays className="h-6 w-6 text-brand-700" aria-hidden="true" />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Editar cita</h1>
        </div>
      </div>
      <AppointmentForm appointment={appointment} />
    </div>
  );
};

export default EditAppointmentPage;
